import React from 'react';
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import DongleIcon from 'components/generic/components/DongleIcon';
import Styled from './YubikeyCard.style';

const YubikeyCard = () => {
  const theme = useTheme();

  return (
    <Styled theme={theme}>
      <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} alignItems="center" spacing={5}>
        <DongleIcon iconLabel={`Y`} />
        <img className="card-dongle-logo" src="/assets/images/card-logos/yubico.svg" alt="safenet" />
      </Stack>
    </Styled>
  );
};

export default YubikeyCard;
